//菜品按日期处理
export function weekforfoods(params) {
  var weekfoods = {
    week1:[],
    week2:[],
    week3:[],
    week4:[],
    week5:[],
    week6:[],
    week7:[],
  }
  
  params.forEach(_ => {
    var num = 'week' + _.week
    weekfoods[num].push(_);
  });
  for (const key in weekfoods) {
    let mealsArray = {}
    var mealsTypeArray = ["早餐","早点","午餐","午点","晚餐","晚点"]
    weekfoods[key].forEach(_ =>{
      let val= _.mealsType;
      mealsArray[val]=mealsArray[val]||[];
      mealsArray[val].push(_);
    })
    var weekArray = []
    for (const key in mealsArray) {
      let mealsArray1 = {
        mealsType: mealsTypeArray[key-1],
        foodsList: mealsArray[key]
      }
      weekArray.push(mealsArray1);
    }
    weekfoods[key] = weekArray
  }
  console.log(weekfoods);
  return weekfoods
}